/**
 * 3DS SDK - Browser-based SDK for 3-D Secure client-side utilities
 *
 * @packageDocumentation
 */

// Export core SDK class
export { ThreeDSSDK } from './core';

// Export types
export type { PaymentResponse, Redirect, ThreeDSAuthResult, SDKConfig } from './types';

export { SDKError } from './types';

// Export modal utility (for advanced usage)
export { ThreeDSModal } from './utils/modal';

// Export fingerprint utility
export { getFingerprint } from './utils/fingerprint';

// Export constants
export { CF_3DS_AUTH_COMPLETE, CF_AUTH_ERROR } from './constants';

// Default export for convenience
export { ThreeDSSDK as default } from './core';
